import { CategoryLists } from '@/models/CategoryKey';

export const ModelKey = {
  Monitors01: 'Monitors_DeskStationaryA',
  Monitors02: 'Monitors_DeskStationaryB',
  Monitors03: 'Monitors_DeskStationaryC',
  Monitors04: 'Monitors_CoinBankA',
  Monitors05: 'Monitors_CoinBankB',
  Monitors06: 'Monitors_CoinBankC',
  Monitors07: 'Monitors_DeskSehlf',
  Monitors08: 'Monitors_BookShelf',
  Monitors09: 'Monitors_StorageBox',
};

export default {
  categoryKey: CategoryLists.Monitors.list.Monitors,
  cover: {
    caption: 'LandingPage.Monitors',
    backgroundImage: require('../../cover_image/cover_DeskStationarySet.jpg'),
    mobileCoverImage: require('../../cover_image/cover_DeskStationarySet.jpg'),
    mainImage: {
      src: require('../../../assets/categories/Monitors.png'),
      pcSrc: require('../../../assets/categories/Monitors.png'),
    },
  },
  box: {
    title: 'ProductPage.selectDesign', //i18n
    list: [
      {
        key: ModelKey.Monitors01,
        image: {
          mobile: require('../../thumbnail/DeskStationaryA.png'),
          pc: require('../../thumbnail/DeskStationaryA.png'),
        },
        title: 'ProductPage.DeskStationary', // i18n
        text: 'A',
        level: 2,
        minutes: 50,
        allowInches: [22,24,27,28,32,34],
      },
      {
        key: ModelKey.Monitors02,
        image: {
          mobile: require('../../thumbnail/DeskStationaryB.png'),
          pc: require('../../thumbnail/DeskStationaryB.png'),
        },
        title: 'ProductPage.DeskStationary', // i18n
        text: 'B',
        level: 3,
        minutes: 60,
        allowInches: [19,22,24,27,28,32,34],
      },
      {
        key: ModelKey.Monitors03,
        image: {
          mobile: require('../../thumbnail/DeskStationaryC.png'),
          pc: require('../../thumbnail/DeskStationaryC.png'),
        },
        title: 'ProductPage.DeskStationary', // i18n
        text: 'C',
        level: 3,
        minutes: 60,
        allowInches: [19,22,24,27,28,32,34]
      },
      {
        key: ModelKey.Monitors04,
        image: {
          mobile: require('../../thumbnail/CoinBankA.png'),
          pc: require('../../thumbnail/CoinBankA.png'),
        },
        title: 'ProductPage.CoinBank', // i18n
        text: 'A',
        level: 2,
        minutes: 60,
        allowInches: [19,22,24,27,28,32,34],
      },
      {
        key: ModelKey.Monitors05,
        image: {
          mobile: require('../../thumbnail/CoinBankB.png'),
          pc: require('../../thumbnail/CoinBankB.png'),
        },
        title: 'ProductPage.CoinBank', // i18n
        text: 'B',
        level: 2,
        minutes: 60,
        allowInches: [22,24,27,28,32,34],
      },

      {
        key: ModelKey.Monitors06,
        image: {
          mobile: require('../../thumbnail/CoinBankC.png'),
          pc: require('../../thumbnail/CoinBankC.png'),
        },
        title: 'ProductPage.CoinBank', // i18n
        text: 'C',
        level: 3,
        minutes: 60,
        allowInches: [24,27,28,32,34],
      },
      {
        key: ModelKey.Monitors07,
        image: {
          mobile: require('../../thumbnail/Book_shelf.png'),
          pc: require('../../thumbnail/Book_shelf.png'),
        },
        title: 'ProductPage.BookShelf', // i18n
        level: 2,
        minutes: 60,
        allowInches: [49],
      },
      {
        key: ModelKey.Monitors08,
        image: {
          mobile: require('../../thumbnail/Desk_shelf.png'),
          pc: require('../../thumbnail/Desk_shelf.png'),
        },
        title: 'ProductPage.DeskShelf', // i18n
        level: 3,
        minutes: 80,
        allowInches: [49],
      },
      {
        key: ModelKey.Monitors09,
        image: {
          mobile: require('../../thumbnail/Storagebox.png'),
          pc: require('../../thumbnail/Storagebox.png'),
        },
        title: 'ProductPage.StorageBox', // i18n
        level: 3,
        minutes: 120,
        allowInches: [49],
      },
    ],
  },
  dezeenBox: {},
  worldcup:{},
  disney:{},
  ModelKey: ModelKey,
};

export const Boxes = {
  [ModelKey.Monitors01]: () => import('./deskstationeryA'),
  [ModelKey.Monitors02]: () => import('./deskstationeryB'),
  [ModelKey.Monitors03]: () => import('./deskstationeryC'),
  [ModelKey.Monitors04]: () => import('./coinbankA'),
  [ModelKey.Monitors05]: () => import('./coinbankB'),
  [ModelKey.Monitors06]: () => import('./coinbankC'),
  [ModelKey.Monitors07]: () => import('./bookshelf'),
  [ModelKey.Monitors08]: () => import('./deskshelf'),
  [ModelKey.Monitors09]: () => import('./storagebox'),
};

